import { useEffect, useState } from "react"

import { useMediaQuery } from "react-responsive"

import { twTheme } from "utils/tw"

const useResponsive = (): {
  isSmMin: boolean
  isSmMax: boolean
  isMd: boolean
  isMdMin: boolean
  isMdMax: boolean
  isLg: boolean
  isLgMin: boolean
  isLgMax: boolean
  isXl: boolean
  isXlMin: boolean
  isXlMax: boolean
  is2XlMin: boolean
} => {
  const [isClient, setIsClient] = useState(false)
  useEffect(() => {
    setIsClient(true)
  }, [])

  const isSmMax = useMediaQuery({
    maxWidth: twTheme.screens.smmax.max
  })

  const isSmMin = useMediaQuery({
    minWidth: twTheme.screens.smmin
  })

  const isMd = useMediaQuery({
    minWidth: twTheme.screens.mdmin,
    maxWidth: twTheme.screens.mdmax.max
  })

  const isMdMin = useMediaQuery({
    minWidth: twTheme.screens.mdmin
  })

  const isMdMax = useMediaQuery({
    maxWidth: twTheme.screens.mdmax.max
  })

  const isLg = useMediaQuery({
    minWidth: twTheme.screens.lgmin,
    maxWidth: twTheme.screens.lgmax.max
  })

  const isLgMin = useMediaQuery({
    minWidth: twTheme.screens.lgmin
  })

  const isLgMax = useMediaQuery({
    maxWidth: twTheme.screens.lgmax.max
  })

  const isXl = useMediaQuery({
    minWidth: twTheme.screens.xlmin,
    maxWidth: twTheme.screens.xlmax.max
  })

  const isXlMin = useMediaQuery({
    minWidth: twTheme.screens.xlmin
  })

  const isXlMax = useMediaQuery({
    maxWidth: twTheme.screens.xlmax.max
  })

  const is2XlMin = useMediaQuery({
    minWidth: twTheme.screens["2xlmin"]
  })

  return {
    isSmMin: isClient ? isSmMin : false,
    isSmMax: isClient ? isSmMax : false,
    isMd: isClient ? isMd : false,
    isMdMin: isClient ? isMdMin : false,
    isMdMax: isClient ? isMdMax : false,
    isLg: isClient ? isLg : false,
    isLgMin: isClient ? isLgMin : false,
    isLgMax: isClient ? isLgMax : false,
    isXl: isClient ? isXl : false,
    isXlMin: isClient ? isXlMin : false,
    isXlMax: isClient ? isXlMax : false,
    is2XlMin: isClient ? is2XlMin : false
  }
}

export default useResponsive
